import React, { Component } from "react";
import PropTypes from "prop-types";

import IntroOutroCard from "cards/containers/IntroOutroCard";
import CompatChunkCard from "cards/containers/CompatChunkCard";

import styles from "./Newsletter.css";

class Newsletter extends Component {

  componentDidMount() {
    let hash = window.location.hash;
    if (hash) {
      const element = document.getElementById(hash.slice(1));
      if (element) {
        setTimeout(() => element.scrollIntoView(), 2000);
      }
    }
  }

  render() {
    const { newsletter } = this.props;
    if (!newsletter) return null;

    return (
      <div role="list" className={styles.newsletterGroup}>

        <IntroOutroCard
          authors={newsletter.authors} 
          story={{ blocks: newsletter.intro }}
        />

        {newsletter.chunks.map((chunk, index) =>
          <CompatChunkCard
            key={chunk.id}
            chunk={chunk}
            index={index}
          />
        )}

        <IntroOutroCard
          story={{ blocks: newsletter.outro }}
        />

      </div>
    );
  }
}

Newsletter.propTypes = {
  newsletter: PropTypes.object,
};

export default Newsletter;
